import type { Match, MatchPerson } from '@uefadigital/panenka';
import { MatchPersonRole } from '@uefadigital/panenka';
import { PkDivider } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { MatchOfficials } from 'components/MatchOfficials';
import { RefereeResults } from 'components/RefereeResults';
import useIsDesktop from 'hooks/useIsDesktop';
import { useMatchData } from 'hooks/useMatchData';
import { isFemale } from 'utils/helpers';

export const MatchOfficialsTab = ({ isPDFPrint = false }) => {
  const { matchData } = useMatchData();

  const { t } = useTranslation();
  const isDesktop = useIsDesktop();

  const {
    competition: { id: competitionId },
  }: Match = matchData;

  const referee = matchData?.referees?.find((ref: MatchPerson) => ref.role === MatchPersonRole.REFEREE);
  const refereeId = referee?.person.id;
  const female = isFemale(competitionId);

  const RefereeResultsComponent = (
    <RefereeResults refereeId={refereeId} competitionId={competitionId} isDesktop={isDesktop} isFemale={female} />
  );
  const MatchOfficialComponent = (
    <MatchOfficials
      refereeData={matchData.referees}
      isDesktop={isDesktop}
      isMatchOfficialsTab
      isPDFPrint={isPDFPrint}
      isFemale={female}
    />
  );

  const titleStyle = clsx(
    'pk-text--text-01 pk-font--comp-bold pk-font-size--xl pk-font-size-md--xl2 pk-font-style--normal',
    isDesktop ? 'pk-line-height--sm' : 'pk-line-height--md',
  );

  return (
    <div className="pk-container">
      <div className="pk-col pk-col--span-12 pk-bg--elevation-01 pr-page-break--before pk-p--xs pk-px-md--xl">
        {MatchOfficialComponent}
        <PkDivider class="divider--horizontal" direction="horizontal" />
        {isDesktop || isPDFPrint ? (
          <div className="pr-avoid-break--inside">
            <div className={clsx('pk-mt--l pk-pr--m pk-mb--l pr-font-size--18', titleStyle)}>
              {t(`latest_main_referee_results${female ? '_f' : ''}`)}
            </div>
            {RefereeResultsComponent}
          </div>
        ) : (
          <>
            <div className={clsx('pk-m--0', titleStyle)}>{t(`latest_main_referee_results${female ? '_f' : ''}`)}</div>
            {RefereeResultsComponent}
          </>
        )}
      </div>
    </div>
  );
};
